import React, {useState} from 'react';

import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import AnimateHeight from 'react-animate-height';
import {connect} from 'react-redux';

import {CART_UPGRADE_RECENTLY_VIEW_OR_ADD} from 'constants/analytics/events/cartUpgrade';
import {ProductPricesType} from 'desktop/types/typesProduct';

import {cookieStore} from 'libs/storage/storage';
import {spawnPriorityTask} from 'libs/timers/spawnPriorityTask/spawnPriorityTask';

import {closeQuickLook, getQuickLookWithAddToCart} from '../../store/actions/quickLook';
import {addUpsellFrameToCart} from '../../store/reducers/addCartItemUpsell/addCartItemUpsell';
import {CartItemEyeglassesOfferFrameType} from '../../types';

import {UpsellFrameConnected} from './frame/frame';

import s from './upsellFrames.scss';

export type PropsType = {
    offerFrames?: Array<CartItemEyeglassesOfferFrameType>;
    cartItemID: string;
    isDefaultOpen?: boolean;
    addUpsellFrameToCart: (data: {itemId: string; productId: string}) => void;
    getQuickLookWithAddToCart: (data: {
        productId: number;
        handler: () => any;
        newPrices: ProductPricesType;
    }) => void;
};

/**
 * Component with 50% sale frames
 */
export const UpsellFrames: React.FC<PropsType> = ({
    addUpsellFrameToCart: addUpsellToCart,
    cartItemID,
    getQuickLookWithAddToCart: getQuickLookAndAdd,
    isDefaultOpen = true,
    offerFrames,
}) => {
    const [isOpen, setIsOpen] = useState(isDefaultOpen);
    const [isOverlay, setIsOverlay] = useState(false);
    const isLuxuryExperience = cookieStore.get('isLuxuryExperience') === 1;

    /**
     * Add upsell to item
     * @param {string} id - upsell id
     * @param {string} event - analytic event name
     */
    const addUpsell = (id: string) => {
        setIsOverlay(true);
        addUpsellToCart({itemId: cartItemID, productId: id});

        spawnPriorityTask(() => {
            sendDesktopAnalyticsEvent(CART_UPGRADE_RECENTLY_VIEW_OR_ADD, 'Add to cart');
        });
    };

    /**
     * Add upsell frame to cart and close quick look popup
     * @param {string} id - upsell id
     */
    const addFromQuickLook = (id: string) => {
        addUpsell(id);
        closeQuickLook();
    };

    /**
     * Open quickLook with button add to cart
     * @param {CartItemEyeglassesOfferFrameType} item - upsell id
     */
    const openQuickLook = ({id, price, specialPrice}: CartItemEyeglassesOfferFrameType) => {
        getQuickLookAndAdd({
            handler: () => addFromQuickLook(String(id)),
            newPrices: {
                finalPrice: specialPrice.toString(),
                price: price.toString(),
            },
            productId: id,
        });
        sendDesktopAnalyticsEvent(CART_UPGRADE_RECENTLY_VIEW_OR_ADD, 'View');
    };

    /**
     * Toggle collapsing block
     */
    const toggleUpsellBlock = () => {
        setIsOpen(!isOpen);
    };

    if (!offerFrames || isLuxuryExperience) return null;

    return (
        <div className={s.upsallesBlock} data-test-name="frameUpsell">
            {isOverlay && <div className={s.overlay} />}
            <button className={s.header} onClick={toggleUpsellBlock} type="button">
                Enjoy 50% off your 2nd frame
            </button>
            <AnimateHeight duration={200} easing="linear" height={isOpen ? 'auto' : 0}>
                {offerFrames.map(item => (
                    <UpsellFrameConnected
                        {...item}
                        addUpsellHandler={() => addUpsell(String(item.id))}
                        key={item.id}
                        quickLookHandler={() => openQuickLook(item)}
                    />
                ))}
            </AnimateHeight>
        </div>
    );
};

export const UpsellFramesConnected = connect(null, {
    addUpsellFrameToCart,
    getQuickLookWithAddToCart,
})(UpsellFrames);
